import React from 'react';
import Card from "./card/Card";
import {SelectedPlanContext} from "./SelectedPlanContext";
import {useMedia} from "react-use";
import Carousel, {consts} from "react-elastic-carousel";
import { ConvertTitle } from "./../constants";


const FlipToFibrePlans = (props) => {
    const isMobile = useMedia("(max-width: 992px)");
    const isTablet = useMedia("(min-width: 768px) and (max-width: 991px)");

    const plans = props.plans.map((plan, key) => {
        const monthlyPrice = props.calcMonthlyPrice(plan);
        return (
            <div onClick={() => props.handleChangeSpeed(plan.id, key)} className="fibrePlan">
                <Card
                    title={ConvertTitle(plan.planSpeed)}
                    key={key}
                    plan={plan}
                    monthlyPrice={monthlyPrice}
                    position={key}
                    active={plan.id === props.selectedPlan.id ? "card-active" : ""}
                />
            </div>
        );
    })

    const mobile = (
        <Carousel
            children={plans}
            itemsToShow={1}
            showArrows={false}
            itemPosition={consts.CENTER}
            outerSpacing={12}
            pagination={true}
            initialFirstItem={2}
        />
    );

    const tablet = (
        <Carousel
            children={plans}
            itemsToShow={2}
            showArrows={false}
            pagination={true}
            outerSpacing={20}
            itemPosition={consts.CENTER}
            initialFirstItem={2}
        />
    );

    const desktop =  (
        <div className="d-flex flex-row gap-4">
            {
                props.plans.map((plan, key) => {
                    const monthlyPrice = props.calcMonthlyPrice(plan);
                    return (
                        <div onClick={event => props.handleChangeSpeed(plan.id, key, event)} className="fibrePlan" key={key}>
                            <Card
                                title={ConvertTitle(plan.planSpeed)}
                                key={key}
                                plan={plan}
                                monthlyPrice={monthlyPrice}
                                position={key}
                                active={plan.id === props.selectedPlan.id ? "card-active" : ""}
                            />
                        </div>
                    );
                })
            }
        </div>
    );


    return (
       <SelectedPlanContext.Provider value={props.selectedPlan}>
           {isMobile ? (isTablet ? tablet : mobile): desktop}
       </SelectedPlanContext.Provider>
    );
}

export default FlipToFibrePlans;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/FlipToFibrePlans.js